<app-tenant-form
    mode="create"
    [isSubmitting]="submitting()"
    (formSubmit)="onSubmit($event)"
></app-tenant-form>
